import React, { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useCart } from "../../context/CartContext";
import Stepper from "../../components/Cart/Stepper/Stepper";
import EmptyCartView from "./EmptyCartView";
import CheckoutLayout from "../../components/Cart/CheckoutLayout/CheckoutLayout";
import "./Cart.css";
import {useTranslation} from "react-i18next";

const CartPage = () => {
  const { items, itemCount, clear } = useCart();
  const { t } = useTranslation();
  const stepLabels = [t("cart.stepper.cart") || "Shopping cart", t("cart.stepper.checkout") || "Checkout details", t("cart.stepper.order") || "Order complete"]
  const [searchParams] = useSearchParams();

  const isSuccess = searchParams.get("success") === "true";
  const isCanceled = searchParams.get("canceled") === "true";
  const paymentStatus = isSuccess ? "success" : isCanceled ? "canceled" : null;
  const hasItems = items && items.length > 0 && itemCount > 0;
  const currentStep = paymentStatus ? 3 : 2;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (isSuccess) {
      clear();
    }
  }, [isSuccess, clear]);

  return (
    <div className="cart-page">
      {!hasItems && !paymentStatus ? (
        <EmptyCartView />
      ) : (
        <div className="cart-container">
          <div className="cart-page__progress">
            <Stepper current={currentStep} labels={stepLabels} />
          </div>
          <CheckoutLayout status={paymentStatus} />
        </div>
      )}
    </div>
  );
};

export default CartPage;
